import { render, staticRenderFns } from "./GFSettings.vue?vue&type=template&id=b456891a&scoped=true"
import script from "./GFSettings.vue?vue&type=script&lang=js"
export * from "./GFSettings.vue?vue&type=script&lang=js"
import style0 from "./GFSettings.vue?vue&type=style&index=0&id=b456891a&prod&scoped=true&lang=css"
import style1 from "./GFSettings.vue?vue&type=style&index=1&id=b456891a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b456891a",
  null
  
)

export default component.exports